/**
 * voteUser接口
 */
import axios from '../utils/https' // 导入http中创建的axios实例

const voteUser = {
  getVoteUserGroups (params) {
    return axios.get('/api/voteUser/GetVoteUserGroups', { params })
  },
  getVoteUserGroup (params) {
    return axios.get('/api/voteUser/GetVoteUserGroup', { params })
  },
  editVoteUserGroup (params) {
    return axios.post('/api/voteUser/EditVoteUserGroup', params)
  },
  deleteVoteUserGroup (params) {
    return axios.delete('/api/voteUser/DeleteVoteUserGroup', { params })
  },
  getDefaultUserGroup (params) {
    return axios.get('/api/voteUser/GetDefaultUserGroup', { params })
  },
  getVoteUsers (params) {
    return axios.get('/api/voteUser/GetVoteUsers', { params })
  },
  getVoteUser (params) {
    return axios.get('/api/voteUser/GetVoteUser', { params })
  },
  editVoteUser (params) {
    return axios.post('/api/voteUser/EditVoteUser', params)
  },
  deleteVoteUser (params) {
    return axios.delete('/api/voteUser/DeleteVoteUser', { params })
  },
  exportMeetingUserTemplate (params) {
    return axios({
      method: 'post',
      url: '/api/voteUser/ExportMeetingUserTemplate',
      data: params,
      responseType: 'blob'
    })
  },
  exportWJUserTemplate (params) {
    return axios({
      method: 'post',
      url: '/api/voteUser/ExportWJUserTemplate',
      data: params,
      responseType: 'blob'
    })
  },
  getUserVoteNumberListByGroupId (params) {
    return axios.get('/api/voteUser/GetUserVoteNumberListByGroupId', { params })
  }
}

export default voteUser
